import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from "react-intl";
import { createSelector } from 'reselect';

import UploadDialogComponent from './ContractFamilyDialog';
import { createContractFamily } from '../../../store/actions/contractFamily';
import { tiny } from '../../../store/actions/contracts';
import { setV2 } from '../../../store/actions/pagesV2';

const selectContractsData = createSelector(
    (state) => state.pages['contracts-landing'].list,
    (data) => {
        return data
    }
);

export const ContractsFamilyDialog = connect(

    () => {
        const selectInitialValues:any = createSelector(
            () => {
                return {
                    contracts: [],
                    name: '',
                    description: ''
                }
            }
        )
        return (state:any, props) => ({
            initialValues: selectInitialValues(state),
            uploadFilePending: state.contractsFamily.create.pending,
            contractsData: selectContractsData(state),
            tinyContracts:state.contracts.tiny


        });
    },
    (dispatch) => ({
        actions: bindActionCreators({
            getTinyContracts: tiny,
            createContractFamily: createContractFamily,
            resetSelectedContracts: () => setV2('contractsv2-landing', 'selected', []),
            setSelectedContracts: (item) => setV2('contractsv2-landing', 'selected', item)


        }, dispatch)
    })
)(injectIntl(UploadDialogComponent));